import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { AssemblyDisassemblyOfGoodsDetail } from "src/components/Pages/Documents/Warehouse/AssemblyDisassemblyOfGoods/components/AssemblyDisassemblyOfGoodsDetail";
import AssemblyDisassemblyOfGoodsList from "src/components/Pages/Documents/Warehouse/AssemblyDisassemblyOfGoods/components/AssemblyDisassemblyOfGoodsList";
import { AssemblyDisassemblyOfGoodsService } from "src/services/documents/AssemblyDisassemblyOfGoodsService";
import { CreateAssemblyDisassemblyOfGoodsDto } from "src/components/Pages/Documents/Warehouse/AssemblyDisassemblyOfGoods/dtos/CreateAssemblyDisassemblyOfGoodsDto";
import { AssemblyDisassemblyOperationTypeEnum } from "src/components/Pages/Documents/Warehouse/AssemblyDisassemblyOfGoods/dtos/AssemblyDisassemblyOperationTypeEnum";
import { NFLookupAssemblyDisassemblyOfGoods } from "src/components/Shared/NewForms/NFLookupAssemblyDisassemblyOfGoods";

export const AssemblyDisassemblyOfGoods: IAppEntity = {
  entityType: "document",
  title: "Assembly/Disassembly Of Goods",
  pluralTitle: "Assembly/Disassembly Of Goods",
  apiUrl: "AssemblyDisassemblyOfGoods",
  apiEnum: ReferenceTypes.DocumentAssemblyDisassemblyOfGood,
  getDetailView: (id?: string) => {
    return React.createElement(AssemblyDisassemblyOfGoodsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(AssemblyDisassemblyOfGoodsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAssemblyDisassemblyOfGoods, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new AssemblyDisassemblyOfGoodsService("AssemblyDisassemblyOfGoods"),
  getEmptyModel: () => {
    const model: CreateAssemblyDisassemblyOfGoodsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      productsMaterials: [],
      quantity: 0,
      createdDate: new Date(),
      operationType: AssemblyDisassemblyOperationTypeEnum.Assembly,
      documentDate: new Date()
    };
    return model;
  }
};
